import { useQuery } from 'react-query';
import { useTokenizedApi } from '../useTokenizedApi';
import { usePersonalProfile } from '../entities/usePersonalProfile';
import { usePrimaryLockbox } from '../treasury/usePrimaryLockbox';
import { useActivityEvent } from '../activity/useActivityEvent';

export function useNewPaymentAsActivityEvent({
  profileId,
  lockboxId,
  recipient,
  instrument,
  sendMax,
  memo,
  isConnecting,
  isConfirming,
}) {
  const tokenizedApi = useTokenizedApi();

  const personalProfile = usePersonalProfile();
  profileId = profileId || personalProfile?.id;

  const primaryLockbox = usePrimaryLockbox(profileId);
  lockboxId = lockboxId || primaryLockbox?.id;

  const lockboxes = useQuery(tokenizedApi.treasury.lockboxesQuery())?.data;

  const activityEvent =
    tokenizedApi.transfers.makeActivityEventForUnconfirmedSend({
      profileId,
      lockboxId,
      recipient,
      instrument,
      sendMax,
      memo,
      isConnecting,
      isConfirming,
      lockboxes,
      ownHandle: personalProfile?.handle,
    });

  return useActivityEvent(activityEvent);
}
